import React from 'react'

const Unchecked = props => (
  <svg width={22.03} height={22.03} {...props}>
    <path
      data-name="Rechthoek 678 kopi\xEBren 4"
      d="M1.01 1h20.02v20.02H1.01V1z"
      fill="none"
      stroke="#000"
      strokeWidth={2}
      fillRule="evenodd"
    />
  </svg>
)

export default Unchecked



// WEBPACK FOOTER //
// ./src/components/shared/unchecked.js